import RequestService from '@tcc-online/request-service';
import IAdminCustomer from '../types/IAdminCustomer';
import { NotificationActions } from '../../common/actions/NotificationActions';
import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';

const AdminCustomerService = {
    getCustomer,
    updateCustomer,
    getCustomers,
    createCustomer,
};

const BASE_URL = '/admin/companies';

async function getCustomer(customerId: number, thunkApi?: GetThunkAPI<any>) {
    try {
        return await RequestService.get<IAdminCustomer>(
            `${BASE_URL}/${customerId}`,
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist firmu'),
        ); // TODO: translate

        throw e;
    }
}

interface BasePayload {
    street?: string;
    city?: string;
    houseNumber?: string;
    postalCode?: string;
    taxNumber?: string;
    registrationNumber?: string;
    languages?: string[];
}

interface UpdatePayload extends BasePayload {
    id: number;
    primaryAdminId?: number | null;
    settings?: Record<string, any> | null;
}

async function updateCustomer(
    payload: UpdatePayload,
    thunkApi?: GetThunkAPI<any>,
) {
    const {
        id,
        street,
        city,
        houseNumber,
        postalCode,
        taxNumber,
        registrationNumber,
        languages,
        primaryAdminId,
        settings,
    } = payload;
    try {
        return await RequestService.patch<
            Omit<UpdatePayload, 'id'>,
            IAdminCustomer
        >(`${BASE_URL}/${id}`, {
            street,
            city,
            houseNumber,
            postalCode,
            taxNumber,
            registrationNumber,
            languages,
            primaryAdminId,
            settings,
        });
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist firmu'),
        ); // TODO: translate

        throw e;
    }
}

async function getCustomers(
    payload: { page?: number },
    thunkApi?: GetThunkAPI<any>,
) {
    const { page = 10 } = payload;
    try {
        return await RequestService.get<IAdminCustomer[]>(`${BASE_URL}`, {
            page,
        });
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist firmy'),
        ); // TODO: translate

        throw e;
    }
}

interface CreatePayload extends BasePayload {
    name: string;
}

async function createCustomer(
    payload: CreatePayload,
    thunkApi?: GetThunkAPI<any>,
) {
    const {
        name,
        street,
        city,
        houseNumber,
        postalCode,
        taxNumber,
        registrationNumber,
        languages,
    } = payload;
    try {
        return await RequestService.post<CreatePayload, IAdminCustomer>(
            `${BASE_URL}`,
            {
                name,
                street,
                city,
                houseNumber,
                postalCode,
                taxNumber,
                registrationNumber,
                languages,
            },
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se vytvorit firmu'),
        ); // TODO: translate

        throw e;
    }
}

export default AdminCustomerService;
